/**
 * 服务数据（四大核心业务）
 * icon: 对应组件内联 SVG 的 key
 */
export const serviceTypes = [
  { value: 'miniProgram', name: '小程序开发' },
  { value: 'app', name: 'App 开发' },
  { value: 'website', name: '网站开发' },
  { value: 'system', name: '系统开发' }
]

export default [
  {
    id: 'miniProgram',
    name: '小程序开发',
    tagline: '微信生态 · 触达十亿用户',
    desc: '从微信/支付宝小程序到商城、餐饮、教育等垂直场景应用，我们提供产品策划、UI 设计、研发与上线审核全流程服务，助力企业快速进入移动互联网阵地。',
    features: [
      '原生小程序 / 跨端 Taro / uni-app 多端复用',
      '微信支付、会员、分销等营销体系深度集成',
      '后台管理系统配套，运营数据一目了然',
      '平台审核一站式代办，快速上线'
    ],
    scenes: ['电商零售', '餐饮连锁', '教育培训', '企业服务', '生活服务'],
    icon: 'miniProgram'
  },
  {
    id: 'app',
    name: 'App 开发',
    tagline: '原生体验 · 打造品牌移动门户',
    desc: '面向 iOS / Android 的定制 App 开发，兼顾流畅体验与品牌调性，支持原生与跨端方案灵活选型，从 0 到 1 构建您的专属移动应用。',
    features: [
      'iOS / Android 双端原生与跨平台方案',
      '消息推送、即时通讯、地图定位等能力接入',
      '高性能架构设计，兼容主流机型',
      '上架各大应用商店全程协助'
    ],
    scenes: ['企业办公', '智能硬件', '社交社区', 'O2O 服务', '行业工具'],
    icon: 'app'
  },
  {
    id: 'website',
    name: '网站开发',
    tagline: '品牌门户 · 企业数字化名片',
    desc: '涵盖企业官网、电商平台、H5 营销页等网站形态，注重品牌视觉与转化率，让每一次访问都成为信任的开始。',
    features: [
      '高端企业官网 / 品牌形象站',
      'B2B / B2C 电商平台搭建',
      'H5 营销活动页、落地页定制',
      'SEO 优化与数据分析埋点'
    ],
    scenes: ['企业形象', '电商零售', '营销推广', 'SaaS 官网', '信息门户'],
    icon: 'website'
  },
  {
    id: 'system',
    name: '系统开发',
    tagline: '业务中台 · 释放管理效能',
    desc: '面向企业内外的管理系统定制开发，覆盖 ERP、CRM、OA、数据可视化大屏等场景，打通业务数据流，让管理决策有据可依。',
    features: [
      'ERP / CRM / OA 等业务系统定制',
      '数据中台与可视化大屏建设',
      '第三方系统 API 集成对接',
      '私有化部署与等保安全合规'
    ],
    scenes: ['生产制造', '仓储物流', '集团管理', '政务服务', '智慧园区'],
    icon: 'system'
  }
]
